import {Component, OnDestroy, OnInit} from '@angular/core';
import {PermissionService} from '../../services/permission.service';
import {StoreService} from '../../services/store.service';
import {IconService} from '../../services/icon.service';
import {Router} from '@angular/router';

@Component({
  selector: 'sidebar',
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnInit, OnDestroy {

  menu: any[] = [];
  routes: any[] = [];

  constructor(public storeService: StoreService,
              private _router: Router,
              private _permissionService: PermissionService) {
    this.routes = this._router.config;
  }

  ngOnInit() {
    this.menu = this.buildMenu();
  }

  ngOnDestroy() {
    this.hide();
  }

  buildMenu(routes = this.routes) {
    const menu = [];

    for (const route of routes) {
      const permission = route.data?.permission;
      const hidden = route.data?.hidden;

      if (!this._permissionService.get(permission) || hidden)
        continue;

      const item: any = {
        path: route.path,
        title: route.data?.title,
        icon: route.data?.icon,
      };

      menu.push(item);
    }

    return menu;
  }

  hide() {
    this.storeService.actions.hideSidebar();
  }
}
